import { Component, Vue, Inject } from "vue-property-decorator";
import DZServiceBanner from '@/views/banner管理/service/DZServiceBanner';
import nyMessageToast from "@/utils/NYMessageToast";
import uploadFile from "@/utils/DZUploadFile";
import ny_config from "@/api/nyConfig";
import api from "@/api/nyApiJson";
import dzMsgBox from "@/utils/DZMessageBox";
@Component({
    components: {}
})
export default class Index extends Vue {

    $refs: any;

    table_height = 0;

    s_banner = new DZServiceBanner();

    is_dialog_show = false;

    created() {
        this.action_list_data()
        this.s_banner.net_list_demand()
        this.s_banner.net_list_homestay()
        this.s_banner.net_list_courtship()
        this.s_banner.net_list_land()
    }

    mounted() {
        this.$nextTick(() => {
            const mainHeight = this.$refs.mainContent.offsetHeight;
            console.log("mainHeight", mainHeight)
            const mainScreen = this.$refs.mainScreen.offsetHeight;
            console.log("mainScreen", mainScreen)
            this.table_height = mainHeight - mainScreen - 50;
        })
    }

    cleanContent(){
        this.s_banner.m_banner.content = ""
    }

    action_list_data(){
        this.s_banner.net_list_banner();
    }

    handle_add(){
        this.is_dialog_show = true
    }

    dialog_close(){
        this.is_dialog_show = false
    }

    action_select_file(file) {
        this.s_banner.m_banner.imageUrl = URL.createObjectURL(file.raw);
        if (file.status == "ready") {
            uploadFile.uploadImage(file.raw,
                (res) => {
                }, (res) => {
                    nyMessageToast.success("图片上传成功")
                    this.s_banner.m_banner.image = res + "";

                }, (res) => {
                    nyMessageToast.error("图片上传失败")
                    this.s_banner.m_banner.image = "";
                    this.s_banner.m_banner.imageUrl = "";
                });
        }
        this.$forceUpdate()
    }

    handle_submit(){
        if (this.s_banner.m_banner.id && this.s_banner.m_banner.id != '') {
            this.s_banner.net_edit_banner(() => {
                this.action_list_data()
                this.dialog_close()
            });
        } else {
            this.s_banner.net_add_banner(() => {
                this.action_list_data()
                this.dialog_close()
            });
        }
    }

    bindImage(id) {
        if (!id) {
            return "";
        }
        let apiName = "显示图片";
        let apiJson: ny_config = api[apiName];
        let url = apiJson.baseUrl + apiJson.url + "?image=" + id
        return url;
    }

    //banner类型：1-土地详情，2-民宿详情，3-需求详情，4-招商详情，5-外挑链接
    bindType(type){
        switch (type){
            case 1: return "土地"
            case 2: return "民宿"
            case 3: return "需求"
            case 4: return "招商"
            case 5: return "链接"
        }
    }


    handle_edit(row){
        let obj = Object.assign({},row)
        this.s_banner.m_banner = obj
        this.s_banner.m_banner.imageUrl = this.bindImage(obj.image)
        this.s_banner.m_banner.type = this.s_banner.m_banner.type + ''
        if(this.s_banner.m_banner.actionType){
            this.s_banner.m_banner.actionType = this.s_banner.m_banner.actionType + ''
        }
        this.is_dialog_show = true
    }

    handle_del(id){
        dzMsgBox.del("是否删除该信息？", () => {
            this.s_banner.net_del_banner(id,() => {
                this.action_list_data()
            });
        })
    }

    handleDbClick(row){
        if(row.id){
            this.handle_edit(row)
        }
    }
}
